import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NewsroomService {
  blog_url = environment.api_url;

  constructor(private httpClient: HttpClient) {}

  getAllData(page: number, limit: number) {
    return new Promise(async (resolve, reject) => {
      this.httpClient
        .get(this.blog_url + 'blog?page=' + page + '&limit=' + limit)
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getDataById(id: string) {
    return new Promise(async (resolve, reject) => {
      this.httpClient.get(this.blog_url + 'blog/' + id).subscribe(
        (res: any) => {
          if (res) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  // api weave news
  weaveApiBaseUrl = 'https://cms.weave.co.id/api/';
  weaveApiToken =
    'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiR3Vlc3QiLCJXZWJzaXRlIjoiV2VhdmUiLCJOYW1lIjoiR3Vlc3QifQ.YZMGbj1kH-gNstTALzPHW8HI52tVEJlSFfD5nab7q4E';
  weaveHttpHeaders = new HttpHeaders({ apiToken: this.weaveApiToken });

  getWeaveNews(page: number, limit: number) {
    return new Promise(async (resolve, reject) => {
      this.httpClient
        .get(
          `${this.weaveApiBaseUrl}news-list?page=${page}&page_size=${limit}`,
          { headers: this.weaveHttpHeaders }
        )
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getWeaveNewsDetail(slug: string) {
    return new Promise(async (resolve, reject) => {
      this.httpClient
        .get(`${this.weaveApiBaseUrl}news-list/${slug}`, {
          headers: this.weaveHttpHeaders,
        })
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  // api surge news
  surgeApiBaseUrl = 'https://cms.surge.co.id/api/';
  surgeApiToken =
    '8a3c746b2643331ca9d7874cab0c760bd46108f06468ec2077abbbda8933c29b';

  getSurgeNews(page: number, limit: number) {
    return new Promise(async (resolve, reject) => {
      this.httpClient
        .get(
          `${this.surgeApiBaseUrl}article?page=${page}&per_page=${limit}&api_token=${this.surgeApiToken}`
        )
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getSurgeNewsDetail(slug: string) {
    return new Promise(async (resolve, reject) => {
      this.httpClient
        .get(
          `${this.surgeApiBaseUrl}article/${slug}?api_token=${this.surgeApiToken}`
        )
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
